import { IRouteConfigsOpts } from 'Src/ng2/routing/route.config';
export const rootRoute: IRouteConfigsOpts = {
  path: '',
  pathMatch: 'full',
  url: '/',
  authenticationRequired: false,
  rolePermissions: ['all'],
  redirectTo: '/district-picker',
};
